import { translateFormatter } from '@/domains/core/localization/translate';
export const nbProductsLabel = translateFormatter<{
  count: number;
  isMax: boolean;
}>([{
  "type": 5,
  "value": "isMax",
  "options": {
    "true": {
      "value": [{
        "type": 0,
        "value": "More than 500 products found"
      }]
    },
    "other": {
      "value": [{
        "type": 6,
        "value": "count",
        "options": {
          "=0": {
            "value": [{
              "type": 0,
              "value": "no products found"
            }]
          },
          "=1": {
            "value": [{
              "type": 7
            }, {
              "type": 0,
              "value": " product found"
            }]
          },
          "other": {
            "value": [{
              "type": 7
            }, {
              "type": 0,
              "value": " products found"
            }]
          }
        },
        "offset": 0,
        "pluralType": "cardinal"
      }]
    }
  }
}], undefined, undefined, "en");
export const nbProductsLabelRevamped = translateFormatter<{
  count: number;
  isMax: boolean;
}>([{
  "type": 5,
  "value": "isMax",
  "options": {
    "true": {
      "value": [{
        "type": 0,
        "value": "500+ products"
      }]
    },
    "false": {
      "value": [{
        "type": 6,
        "value": "count",
        "options": {
          "=0": {
            "value": [{
              "type": 0,
              "value": "no products found"
            }]
          },
          "=1": {
            "value": [{
              "type": 0,
              "value": "1 product"
            }]
          },
          "other": {
            "value": [{
              "type": 7
            }, {
              "type": 0,
              "value": " products"
            }]
          }
        },
        "offset": 0,
        "pluralType": "cardinal"
      }]
    }
  }
}], undefined, undefined, "en");